import { ProductStatus } from "../constants";
import { MemberProduct } from "@/src/features/api/memberApi";

/**
 * 获取产品列表中的试用期产品
 *
 */
export const getTrialData = ({
  trialList,
  id,
}: {
  trialList: MemberProduct[];
  id?: string;
}) => {
  return trialList.find(
    (item) => item.renewal_id === id && item.status === ProductStatus.ACTIVE,
  );
};
